// import { Navigate } from 'react-router-dom';
// import { useAuth } from '../hooks/useAuth';

// const PublicRoute = ({ children }) => {
//     const { isAuthenticated } = useAuth();

//     if (isAuthenticated) {
//         return <Navigate to="/dashboard" replace />;
//     }

//     return children;
// };

// export default PublicRoute;
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PublicRoute = ({ children }) => {
  // const { isAuthenticated, loading } = useAuth();

  // if (loading) {
  //   return null;
  // }
  const { isAuthenticated } = useAuth();

  // if (loading) {
  //   return null;
  // }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;